import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import './css/Navbar.css';
import './css/Fonts.css';
import logo from './img/inforight_logo_transparent.png';

const links = [
  { to: '/products', label: 'Products' },
  { to: '/services', label: 'Services' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/about', label: 'About' },
];

function NavBar() {
  return (
    <Navbar className="site-navbar" expand="lg" fixed="top" variant="dark">
      <Container className="site-navbar-inner">
        <Navbar.Brand as={Link} to="/" className="site-brand">
          <img alt="InfoRight" src={logo} width="32" height="32" className="d-inline-block" />
          <span className="site-brand-name">InfoRight</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="site-nav" />
        <Navbar.Collapse id="site-nav">
          <Nav className="ms-auto site-nav-links">
            {links.map((link) => (
              <NavLink key={link.to} to={link.to} className="nav-link site-nav-link">
                {link.label}
              </NavLink>
            ))}
            <Button variant="" as={Link} to="/contact" className="site-nav-cta">
              Request a Demo
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
